import script from "./CompanyLargeIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyLargeIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__